import { Outlet } from 'react-router-dom';

export default function MicrositeLayout() {
  return (
    <div className="h-[100dvh] overflow-y-auto overflow-x-hidden">
      <Outlet />
    </div>
  );
}
